exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .navigationBar_homeIcon__1GhmK{margin-bottom:80%;margin-top:80%}", ""]);

// Exports
exports.locals = {
	"homeIcon": "navigationBar_homeIcon__1GhmK"
};